<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onSubmit"
  >
    <div class="row">
      <div class="col-md-6">
        <el-form-item label="Название" prop="title">
          <el-input v-model="form.title" />
          {{ $_ErrorMixin_getError('title') }}
        </el-form-item>

        <el-form-item label="Название (RU)" prop="title_ru">
          <el-input v-model="form.title_ru" />
          {{ $_ErrorMixin_getError('title_ru') }}
        </el-form-item>

        <el-form-item label="Позиция" prop="position">
          <el-input-number v-model="form.position" :min="0" />
          {{ $_ErrorMixin_getError('position') }}
        </el-form-item>

        <el-form-item label="Категория" prop="category_id">
          <el-select
            v-model="form.category_id"
            clearable
            filterable
            placeholder="Выберите категорию"
          >
            <el-option
              v-for="item in availableCategories"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          {{ $_ErrorMixin_getError('category_id') }}
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { mapActions } from 'vuex'
import ErrorMixin from '@/utils/ErrorMixin'

const defaultValues = {
  category_id: '',
  id: '',
  position: '',
  title: '',
  title_ru: '',
}

export default {
  name: 'TreeForm',
  mixins: [ErrorMixin],
  data() {
    return {
      form: { ...defaultValues },
      categories: [],
      availableCategories: [],
      loading: false,
      rules: {
        title: [
          { required: true, message: 'Пожалуйста, введите название', trigger: 'blur' },
        ],
        title_ru: [
          { required: true, message: 'Пожалуйста, введите название на русском', trigger: 'blur' },
        ],
        position: [
          { required: true, message: 'Пожалуйста, укажите позицию', trigger: 'blur' },
          { type: 'number', message: 'Позиция должна быть числом', trigger: 'blur' },
        ],
        category_id: [
          { required: true, message: 'Нужно выбрать категорию', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    isUpdate() {
      return this.$route.name === 'UpdateCategoryAttribute'
    },
  },
  async created() {
    await this.getParamsFromRouter()
    this.categories = await this.fetchCategories()
    this.availableCategories = this.categories.flatMap(category => category.children || []);
  },
  methods: {
    ...mapActions('wishes/categories', ['createAttribute', 'updateAttribute', 'getAttributeById', 'fetchCategories']),
    async onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            if (this.isUpdate) {
              await this.updateAttribute( { id: this.$route.params.id, form: this.form })
              this.$message.success('Атрибут успешно обновлен')
            } else {
              await this.createAttribute(this.form)
              this.$message.success('Атрибут успешно создан')
            }
            this.$_ErrorMixin_clearErrors()
            await this.$router.push({ name: 'CategoryAttributes' })
          } catch (error) {
            this.$_ErrorMixin_handleError(error)
          }
        }
      })
    },
    async getParamsFromRouter() {
      const id = this.$route.params.id
      if (id) {
        const model = await this.getAttributeById(id)
        this.fillForm(model)
      }
    },
    fillForm(model) {
      this.form = {
        ...this.form,
        ...model,
      }
      this.form.category_id = model.category.id
    },
  },
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

.switch-label {
  margin-left: 10px;
  vertical-align: middle;
}

.el-switch {
  vertical-align: middle;
}
</style>
